import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Container, FormControlLabel, Grid, Radio } from "@mui/material";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import { onboardingConstants } from "../../../../_redux/_constants";
import { ProgressBar } from "../../../_uiComponents/Onboarding/ProgressBar";
import PreferImg from "../../../../styles/img/onboard/prefered-img.png";
import UiRadioInput from "../../../_uiComponents/common/UiRadioInput";
import {
  assignRegistrationType,
  assignVerificationType,
  onboardingClearFormResponseData,
} from "../../../../_redux/_actions/onboarding.actions";
import { UiPopup } from "../../../_uiComponents/common/UiModal";
import { ConfirmationIcon } from "../../../../styles/img/svg/ConfirmationIcon";
import { SomethingWrongModal } from "../../../_uiComponents/Popups/SomethingWrongModal";
import { UiOptionBox } from "../../../_uiComponents/Onboarding/UiOptionBox";

export const VerificationOption = (props) => {
  const { ownFormData: ownFormData } = useSelector((state) => state.onboarding);
  const { t, i18n } = useTranslation();

  const [isContactUsOpen, setIsContactUsOpen] = useState(false);

  const [selectedOption, setSelectedOption] = useState(
    ownFormData?.verifcationType
      ? ownFormData.verifcationType
      : onboardingConstants.VERIFICATION_OPTION_CALL_CENTER,
  );
  const dispatch = useDispatch();

  const submit = (option) => {
    dispatch(assignVerificationType({ verifcationType: option }));

    if (option) {
      switch (option) {
        case onboardingConstants.VERIFICATION_OPTION_CALL_CENTER:
          setIsContactUsOpen(true);
          break;

        case onboardingConstants.VERIFICATION_OPTION_VISIT_BRANCH:
          props?.changeFlowStep(
            onboardingConstants.VERIFICATION_IN_PROGRESS_STEP,
          );
          break;

        default:
          break;
      }
    }
  };

  const OptionSelected = (option) => {
    props?.setIsFormDirty(true);
    setSelectedOption(option);
    submit(option);
  };

  useEffect(() => {
    if (ownFormData?.registrationType) {
      props?.setIsFormDirty(true);
    }
  }, [ownFormData]);

  const goBack = () => {
    dispatch(onboardingClearFormResponseData());
    if (
      ownFormData?.registrationType ==
      onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT
    ) {
      props?.changeFlowStep(
        onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT,
      );
    }

    if (
      ownFormData?.registrationType ==
      onboardingConstants.REGISTRATION_OPTION_CREDIT_CARD
    ) {
      // to do the credit card flow
      props?.changeFlowStep(
        onboardingConstants.REGISTRATION_OPTION_CREDIT_CARD,
      );
    }
  };

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div
            className="df-user-profile__close-icon"
            onClick={props?.closeBtn}
          >
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <ProgressBar
              noOfActive={4}
              total={
                ownFormData?.registrationType ==
                onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT
                  ? 7
                  : 6
              }
            />

            <BackIcon onClick={goBack} />
          </div>

          <div className="df-user-profile__body df-pw-tab">
            <Grid container>
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
                <h2 className="df-reset-pw-title text-center">
                  {t("Select your preferred mode of verification")}
                </h2>

                <img
                  src={PreferImg}
                  className="df-reset-pw-img df-onboard-side-img"
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-right df-pl-2 df-align-center"
              >
                <div className="df-onboard-radio df-onboard-nic-wr">
                  <div className="df-onboard-radio df-onboard-nic-wr df-prefered-radio">
                    <div className="df-options-container df-prefered-options">
                      <UiOptionBox
                        label="Request a Verification Call"
                        value={
                          onboardingConstants.VERIFICATION_OPTION_CALL_CENTER
                        }
                        selected={
                          selectedOption ===
                          onboardingConstants.VERIFICATION_OPTION_CALL_CENTER
                        }
                        onClick={() => {
                          OptionSelected(
                            onboardingConstants.VERIFICATION_OPTION_CALL_CENTER,
                          );
                        }}
                      />
                      {/* <UiOptionBox
                        label="I’m at a LOLC Branch"
                        value={
                          onboardingConstants.VERIFICATION_OPTION_VISIT_BRANCH
                        }
                        selected={
                          selectedOption ===
                          onboardingConstants.VERIFICATION_OPTION_VISIT_BRANCH
                        }
                        onClick={() => {
                          OptionSelected(
                            onboardingConstants.VERIFICATION_OPTION_VISIT_BRANCH,
                          );
                        }}
                      /> */}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <UiPopup
        openModal={isContactUsOpen}
        handleClose={() => {
          setIsContactUsOpen(false);
          props?.changeFlowStep(
            onboardingConstants.VERIFICATION_IN_PROGRESS_STEP,
          );
        }}
      >
        <SomethingWrongModal
          icon={<ConfirmationIcon />}
          message={t("LOLC Customer Support")}
          buttonText={t("Ok")}
          buttonOnClick={() => {
            setIsContactUsOpen(false);
            props?.changeFlowStep(
              onboardingConstants.VERIFICATION_IN_PROGRESS_STEP,
            );
          }}
          className="df-confirmation-message-popup "
          buttonClass="df-ui-dark-bg-btn df-w-90-btn"
        >
          <p>{t("For assistance, call Customer Support at")} </p>

          <div className="df-onboarding-alert-customer-support">
            <a
              className="df-primary-underlined-btn df-modal-support-text"
              href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
            >
              {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
            </a>
          </div>
        </SomethingWrongModal>
      </UiPopup>
    </>
  );
};
